<template>
  <div>
    <cx-check-box :value.sync="showyAxis">显示纵轴</cx-check-box>
    <div v-if="showyAxis && checkType(showyAxis)">
      <div v-if="chartOpt.yAxis && chartOpt.yAxis.type === 'value'">
        <div class="mt16">
          <span class="font14 mr16 inlineMiddle">纵轴段数</span>
          <el-radio-group v-model="hasSplitNumber" @change="typeChange">
            <el-radio value="auto" label="auto">自动</el-radio>
            <el-radio value="self" label="self">自定义</el-radio>
          </el-radio-group>
        </div>
        <div v-if="hasSplitNumber === 'self'">
          <slider-and-input
            class="mt12"
            :value.sync="splitNumber"
            title=""
            :sliderMax="100"
            :sliderMin="1"
            inputWidth="large"
            inputHeight="small"
            suffix="段"
            titlePosition="singleLine"
          />
        </div>
        <div class="mt16">
          <span class="font14 mr16 inlineMiddle">纵轴数值</span>
          <el-radio-group v-model="hasMaxMin" @change="typeChangeMaxMin">
            <el-radio value="auto" label="auto">平均值</el-radio>
            <el-radio value="self" label="self">自定义</el-radio>
          </el-radio-group>
        </div>
        <div v-if="hasMaxMin === 'self'">
          <slider-and-input class="mt12" :value.sync="min" title="最小值" :sliderMax="10000" :sliderMin="0" suffix="" />
          <slider-and-input
            class="mt12"
            :value.sync="max"
            title="最大值"
            :sliderMax="1000000"
            :sliderMin="1"
            suffix=""
          />
        </div>
      </div>
      <div>
        <p class="font14 mb16 mt16">纵轴文字</p>
        <!-- 字体和颜色/字重和字号 -->
        <text-setting-update
          colorMode="chart"
          :fontColor.sync="yAxisFontColor"
          :fontFamily.sync="yAxisFontFamily"
          :fontSize.sync="yAxisFontSize"
          :fontWeight.sync="yAxisFontWeight"
        />
      </div>
      <slider-and-input
        class="mt16"
        v-if="checkType(yAxisLabelInterval) && yAxisData.length"
        :value.sync="yAxisLabelInterval"
        title="轴文字间距"
        :sliderMin="0"
        :sliderMax="10"
        suffix="位"
      />
      <slider-and-input
        class="mt16"
        v-if="checkType(yAxisLabelPaddingBottom)"
        :value.sync="yAxisLabelPaddingBottom"
        title="下边距"
        :sliderMin="-50"
        :sliderMax="50"
        suffix="px"
      />
      <slider-and-input
        class="mt16"
        v-if="checkType(yAxisLabelPaddingRight)"
        :value.sync="yAxisLabelPaddingRight"
        title="右边距"
        :sliderMin="-30"
        :sliderMax="200"
        suffix="px"
      />
      <cx-check-box class="mt16" :value.sync="showYAxisTextBackground">{{ axisLabelText }}</cx-check-box>
      <!--文本背景色/圆角/边距设置-->
      <div v-if="showYAxisTextBackground">
        <double-input
          class="mt16"
          title="尺寸"
          placeHolderText="必填"
          :value1.sync="yAxisLabelPaddingWidth"
          :value2.sync="yAxisLabelPaddingHeight"
          inputSuffixs="px"
        />
        <!--轴线文本边框圆角-->
        <slider-and-input
          class="mt16"
          v-if="checkType(yAxisLabelBorderRadius)"
          :value.sync="yAxisLabelBorderRadius"
          title="圆角"
          :sliderMax="15"
          suffix="px"
        />
        <!--轴线文本边框右边距-->
        <slider-and-input
          class="mt16"
          v-if="checkType(yAxisLabelMargin)"
          :value.sync="yAxisLabelMargin"
          title="右边距"
          :sliderMax="100"
          :sliderMin="-100"
          suffix="px"
        />
        <!-- 默认文字背景色 -->
        <color-picker
          v-if="typeof YAxisTextBackground === 'string'"
          class="mt16"
          :color.sync="YAxisTextBackground"
          titlePosition="singleLine"
          title="默认背景色"
        />
        <div v-else>
          <label class="font14 inlineMiddle mr24 mt16">默认背景色</label>
          <color-picker
            class="mt16"
            :color="YAxisTextBackground.colorStops[1].color"
            @change="changePrimaryBackgroundColor(1, $event)"
            titlePosition="allInOneLine"
            title="开始颜色"
          />
          <color-picker
            class="mt16"
            :color="YAxisTextBackground.colorStops[0].color"
            @change="changePrimaryBackgroundColor(0, $event)"
            titlePosition="allInOneLine"
            title="结束颜色"
          />
        </div>
        <!-- 特殊背景色 -->
        <div class="mt16" v-if="yAxisData.length">
          <label class="font14 inlineMiddle mr24"
            >特殊背景色<span @click="addBackgroundControl" class="icon-portal-plus-small right_font"
          /></label>

          <div
            class="single_bg"
            v-for="(rich, key) in singleBackground"
            :key="rich.name"
            @dragover.prevent
            @drop="stopChangePosition(rich, $event)"
          >
            <div class="single_color_icons">
              <div class="icon_set">
                <img :src="Vector" draggable="true" @dragstart="startChangePosition(rich, $event)" />
              </div>
              <div class="icon_set">
                <span @click="delRchSingleColor(rich, key)" class="icon-portal-delete" />
              </div>
            </div>
            <div class="selectRichType">
              <el-radio-group :value="getRichBgType(rich)" @change="changeRankBgType(rich, $event)" @input="getLabel">
                <el-radio label="纯色">纯色</el-radio>
                <el-radio label="线性渐变">线性渐变</el-radio>
                <el-radio label="图片">图片</el-radio>
              </el-radio-group>
            </div>
            <color-picker
              class="mt12"
              v-if="typeof rich.backgroundColor === 'string'"
              @change="changeRichColor(rich, undefined, $event)"
              :color="rich.backgroundColor"
            />
            <div
              class="data-item mt12"
              v-else-if="typeof rich.backgroundColor === 'object' && 'image' in rich.backgroundColor"
            >
              <img-upload-simple :imgSrc.sync="rich.backgroundColor.image" />
            </div>
            <div v-else>
              <color-picker
                class="mt12"
                :color="rich.backgroundColor.colorStops[1].color"
                @change="changeRichColor(rich, 1, $event)"
                title="开始颜色"
                titlePosition="singleLine"
              />
              <color-picker
                class="mt8"
                :color="rich.backgroundColor.colorStops[0].color"
                @change="changeRichColor(rich, 0, $event)"
                titlePosition="singleLine"
                title="结束颜色"
              />
            </div>
          </div>
          <!-- <span></span><span></span> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="mt16" v-if="this.axisLabelType">
        <label class="font14 inlineMiddle mr24">柱上文字设置</label>
        <text-setting-update
          class="mt8"
          colorMode="chart"
          :fontColor.sync="yAxisLabelTextOnBarFontColor"
          :fontFamily.sync="yAxisLabelTextOnBarFonFamily"
          :fontSize.sync="yAxisLabelTextOnBarFontSize"
          :fontWeight.sync="yAxisLabelTextOnBarFontWeight"
        />
        <slider-and-input
          v-if="checkType(yAxisLabelPaddingBottomTextOnBar)"
          class="mt8"
          :value.sync="yAxisLabelPaddingBottomTextOnBar"
          title="下边距"
          :sliderMax="100"
          :sliderMin="-100"
          suffix="px"
        />
        <slider-and-input
          v-if="checkType(yAxisLabelPaddingLeftTextOnBar)"
          class="mt8"
          :value.sync="yAxisLabelPaddingLeftTextOnBar"
          title="左边距"
          :sliderMax="100"
          suffix="px"
        />
        <cx-check-box :value.sync="yAxisDataValueMaxLengthControl" class="mt16">文字长度限制</cx-check-box>
        <div class="text-limit-box verticallyCenter" v-if="yAxisDataValueMaxLengthControl">
          <span>超出</span>
          <single-input class="text-limit-ipt" :value.sync="yAxisDataValueMaxLength" inputSuffixs="个" />
          <!--          <el-input type="text" v-model="yAxisDataValueMaxLength" class="text-limit-ipt">-->
          <!--            <template slot="suffix">-->
          <!--              <span class="suffix_text">个</span>-->
          <!--            </template>-->
          <!--          </el-input>-->
          <span>省略</span>
        </div>
        <!-- <slider-and-input
          v-if="yAxisDataValueMaxLengthControl && checkType(yAxisDataValueMaxLength)"
          class="mt8"
          :value.sync="yAxisDataValueMaxLength"
          title="文字长度"
          :sliderMax="100"
          suffix="个"
        /> -->
      </div>
      <!--单位设置-->
      <div class="mt16" v-if="checkType(showYAxisUnit)">
        <cx-check-box :value.sync="showYAxisUnit">显示单位</cx-check-box>
        <div class="mt16" v-if="showYAxisUnit">
          <span class="font14 mr10 half-label">单位文本</span>
          <el-input
            class="width-half-bigWidth el-input el-input--suffix"
            placeholder="请输入"
            v-model="showYAxisUnitValue"
          >
          </el-input>
        </div>
        <!-- 单位文字设置 -->
        <div class="mt16" v-if="showYAxisUnit">
          <text-setting-update
            colorMode="chart"
            :fontColor.sync="yAxisUnitValueFontColor"
            :fontFamily.sync="yAxisUnitValueFontFamily"
            :fontSize.sync="yAxisUnitValueFontSize"
            :fontWeight.sync="yAxisUnitValueFontWeight"
          />
          <slider-and-input
            class="mt16"
            :value.sync="yAxisUnitValuepaddingBottom"
            title="单位上边距"
            :sliderMax="50"
            :sliderMin="-50"
            suffix="px"
          />
          <slider-and-input
            class="mt16"
            :value.sync="yAxisUnitValuepaddingLeft"
            title="单位左边距"
            :sliderMax="50"
            :sliderMin="-50"
            suffix="px"
          />
        </div>
      </div>
      <!-- <div class="mt16" v-if="options.type === 'Line'"> -->
      <!-- <div class="mt16" v-if="options.type === 'Line'"> -->
      <!-- <div class="mt16"> -->

      <!--文字长度限制-->
      <cx-check-box v-if="showAxisLabelLimit" :value.sync="axisLabelLenControl" class="mt16"
        >纵轴文字长度限制</cx-check-box
      >
      <div class="text-limit-box verticallyCenter mt16" v-if="axisLabelLenControl">
        <span>超出</span>

        <single-input class="text-limit-ipt" :value.sync="axisLabelLen" inputSuffixs="个" />
        <!--        <el-input type="text" v-model="axisLabelLen" class="text-limit-ipt">-->
        <!--          <template slot="suffix">-->
        <!--            <span class="suffix_text">个</span>-->
        <!--          </template>-->
        <!--        </el-input>-->
        <span>省略</span>
      </div>
      <!--轴线类型-->
      <div class="mt16" v-if="min && max">
        <double-input
          titlePosition="singleLine"
          class=""
          title="纵轴范围"
          placeHolderText="自动"
          :value1.sync="min"
          :value2.sync="max"
          inputSuffixs="px"
        />
      </div>
    </div>
    <div class="mt16" v-if="checkType(yAxisLineType) || checkType(yAxisLineWidth) || checkType(yAxisLabelColor)">
      <!-- <div class="mt16"> -->
      <!--轴线类型-->
      <div class="mt16 verticallyCenterAround">
        <line-setting
          title="轴线样式"
          :lineName.sync="yAxisLineType"
          :lineWidth.sync="yAxisLineWidth"
          :lineColor.sync="yAxisLabelColor"
        />
      </div>
    </div>
    <div class="mt16">
      <cx-check-box :value.sync="yAxisInverse">坐标轴反转</cx-check-box>
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
import Vector from "assets/images/Vector.png"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      Vector,
      this1: this,
      barSettingType: "single",
      singleBackground: [],
      nowLabel: "",
      hasSplitNumber: "auto",
      hasMaxMin: "auto"
    }
  },
  computed: {
    axisLabelType() {
      //ture代表当前柱状图是排序的且有描述文字的纵轴，false表示是普通的
      let chartOpt = {
        yaxis: {
          axisLabel: {
            rich: {
              rank: {}
            }
          }
        }
      }
      return !!this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank")
    },
    axisLabelText() {
      return this.axisLabelType ? "显示纵轴排序文字背景" : "显示纵轴文字背景"
    },
    chartOpt() {
      return this.options.chartOption
    },

    yAxisData() {
      return this.hasProperty(this.chartOpt, "yAxis.data")
    },
    showYAxisUnitValue: {
      get() {
        return this.chartOpt.yAxis.name
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.name", false)
      }
    },
    showYAxisUnit: {
      get() {
        return !!this.chartOpt.yAxis.name?.length
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV(" ", "chartOption.yAxis.name", false)
        } else {
          this.$changeOptionsEV("", "chartOption.yAxis.name", false)
        }
      }
    },
    yAxisUnitValueFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          "yAxis.nameTextStyle.fontFamily",
          "yAxis.nameTextStyle.fontFamily",
          "sans-serif"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.nameTextStyle.fontFamily", false)
      }
    },
    yAxisUnitValueFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          "yAxis.nameTextStyle.fontSize",
          "yAxis.nameTextStyle.fontSize",
          12
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.nameTextStyle.fontSize", false)
      }
    },
    yAxisUnitValueFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          "yAxis.nameTextStyle.fontWeight",
          "yAxis.nameTextStyle.fontWeight",
          400
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.nameTextStyle.fontWeight", false)
      }
    },
    yAxisUnitValueFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          "yAxis.nameTextStyle.color",
          "yAxis.nameTextStyle.color",
          "rgba(255,255,0,1)"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.nameTextStyle.color", false)
      }
    },
    yAxisUnitValuepaddingBottom: {
      get() {
        return -this.hasProperty(this.chartOpt, "yAxis.nameTextStyle.padding.2")
      },
      set(newVal) {
        this.$changeOptionsEV(-newVal, "chartOption.yAxis.nameTextStyle.padding.2", false)
      }
    },
    yAxisUnitValuepaddingLeft: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.nameTextStyle.padding.3")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.nameTextStyle.padding.3", false)
      }
    },
    splitNumber: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.splitNumber", "yAxis.splitNumber", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.splitNumber", false)
      }
    },
    min: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.min", "yAxis.min", 0)
      },
      set(newVal) {
        if (typeof newVal !== undefined) {
          this.$changeOptionsEV(newVal, "chartOption.yAxis.min", false)
        }
      }
    },
    max: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.max", "yAxis.max", "dataMax")
      },
      set(newVal) {
        if (typeof newVal !== undefined) {
          if(newVal === "dataMax"){
            if(this.options.type === "Bar" && this.chartOpt.styleId === 12){
              // 柱状图样式12需要特殊处理
              this.$changeOptionsEV(newVal, "chartOption.yAxis.max", false)
            }else{
              this.$changeOptionsEV(null, "chartOption.yAxis.max", false)
            }
          } else {
            this.$changeOptionsEV(newVal, "chartOption.yAxis.max", false)
          }
          if(this.options.type === "Bar" && this.chartOpt.styleId === 12){
            // 柱状图样式12需要根据纵轴数值最大值来修改第四组数据的最大值，为了解决展示背景颜色时的数据不对情况
            let dataArrMax = []
            if(typeof newVal === "number"){
              for(let j=0; j<this.chartOpt.series[0].data.length;j++){
                dataArrMax.push(newVal)
              }
            }else{
              let dataArr1 = []
              this.chartOpt.series[0].data.forEach((item, index)=>{
                dataArr1.push(item.value)
              })
              let maxVal = Math.max(...dataArr1)
              for(let j=0; j<this.chartOpt.series[0].data.length;j++){
                dataArrMax.push(maxVal)
              }
            }
            this.$changeOptionsEV(dataArrMax, "chartOption.series.3.data", false)
          }
        }
      }
    },
    yAxisLabelInterval: {
      get() {
        return this.hasProperty(this.chartOpt, `yAxis.axisLabel.interval`)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.interval", false)
      }
    },
    yAxisLabelPaddingBottom: {
      get() {
        return this.hasProperty(this.chartOpt, `yAxis.data.0.textStyle.padding.2`)
      },
      set(newVal) {
        if (newVal !== this.yAxisLabelPaddingBottom) {
          const values = []
          const names = []
          this.chartOpt.yAxis.data.forEach((itemData, index) => {
            values.push(newVal)
            names.push(`chartOption.yAxis.data.${index}.textStyle.padding.2`)
          })
          this.$changeOptionsEV(values, names, false)
        }
      }
    },
    yAxisLabelPaddingRight: {
      get() {
        return this.hasProperty(this.chartOpt, `yAxis.data.0.textStyle.padding.1`)
      },
      set(newVal) {
        if (newVal !== this.yAxisLabelPaddingRight) {
          const values = []
          const names = []
          this.chartOpt.yAxis.data.forEach((itemData, index) => {
            values.push(newVal)
            names.push(`chartOption.yAxis.data.${index}.textStyle.padding.1`)
          })
          this.$changeOptionsEV(values, names, false)
        }
      }
    },
    showyAxis: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.show", "yAxis.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.show", false)
      }
    },
    //轴线文字设置
    yAxisFontFamily: {
      get() {
        return this.quickGetRankProperty("fontFamily")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontFamily")
      }
    },
    yAxisFontColor: {
      get() {
        return this.quickGetRankProperty("color")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "color")
      }
    },
    yAxisFontWeight: {
      get() {
        return this.quickGetRankProperty("fontWeight")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontWeight")
      }
    },
    yAxisFontSize: {
      get() {
        return this.quickGetRankProperty("fontSize")
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "fontSize")
      }
    },
    //轴线文字设置结束
    yAxisLabelColor: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLine.lineStyle.color", false)
      }
    },
    yAxisLineType: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLine.lineStyle.type", false)
      }
    },
    yAxisLineWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLine.lineStyle.width", false)
      }
    },
    showYAxisTextBackground: {
      get() {
        if (this.axisLabelType) {
          //排序柱状图的情况
          return (
            this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank0.backgroundColor") !== "rgba(255, 255, 0, 0)"
          )
        } else {
          //普通柱状图的情况
          return this.hasProperty(this.chartOpt, "yAxis.axisLabel.backgroundColor") !== "rgba(255, 255, 0, 0)"
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          if (newVal) {
            //柱状图样式7举例：显示背景颜色初始化为第一个rank值
            let rankDefaultBg = this.chartOpt.yAxis.axisLabel.rich.rank.backgroundColor
            console.log(rankDefaultBg)
            if (rankDefaultBg) {
              this.forEachSetRankProperty(rankDefaultBg, "backgroundColor")
            }
          } else {
            this.forEachSetRankProperty("rgba(255, 255, 0, 0)", "backgroundColor")
          }
        } else {
          if (newVal) {
            this.$changeOptionsEV("rgba(252, 73, 28, 1)", "chartOption.yAxis.axisLabel.backgroundColor", false)
          } else {
            this.$changeOptionsEV("rgba(255, 255, 0, 0)", "chartOption.yAxis.axisLabel.backgroundColor", false)
          }
        }
      }
    },
    YAxisTextBackground: {
      get() {
        if (this.axisLabelType) {
          //排序柱状图的情况
          return this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank.backgroundColor")
        } else {
          //普通柱状图的情况
          return this.checkAndSetPrimaryVal(
            this.chartOpt,
            "yAxis.axisLabel.backgroundColor",
            "yAxis.axisLabel.backgroundColor",
            "rgba(255, 255, 0, 0)"
          )
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.yAxis.axisLabel.rich
          const values = [newVal]
          const names = [`chartOption.yAxis.axisLabel.rich.rank.backgroundColor`]
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length && !ranks[k].singleColor) {
              values.push(newVal)
              names.push(`chartOption.yAxis.axisLabel.rich.${k}.backgroundColor`)
            }
          })
          this.$changeOptionsEV(values, names, false)
        } else {
          this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.backgroundColor", false)
        }
      }
    },
    yAxisLabelPaddingBottomTextOnBar: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.title.padding.2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.rich.title.padding.2", false)
      }
    },
    yAxisLabelPaddingLeftTextOnBar: {
      get() {
        return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.title.padding.3"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.rich.title.padding.3", false)
      }
    },
    yAxisDataValueMaxLengthControl: {
      //柱上文字长度限制
      get() {
        console.log("dataValueLengthControl", this.hasProperty(this.chartOpt, "yAxis.dataValueLengthControl"))
        return this.hasProperty(this.chartOpt, "yAxis.dataValueLengthControl")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.dataValueLengthControl`, false)
      }
    },
    yAxisDataValueMaxLength: {
      //柱上文字长度限制
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.dataValueLength")
      },
      set(newVal) {
        const oldVal = this.hasProperty(this.chartOpt, "yAxis.dataValueLength")
        if (newVal === oldVal) return
        this.$changeOptionsEV(newVal, `chartOption.yAxis.dataValueLength`, false)
      }
    },
    //柱上文字设置
    yAxisLabelTextOnBarFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.title.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.rich.title.color`, false)
      }
    },
    yAxisLabelTextOnBarFontSize: {
      get() {
        return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.title.fontSize"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.rich.title.fontSize`, false)
      }
    },
    yAxisLabelTextOnBarFonFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt.yAxis.axisLabel.rich.title,
          "fontFamily",
          "fontFamily",
          "sans-serif"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.rich.title.fontFamily`, false)
      }
    },
    yAxisLabelTextOnBarFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.title.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.rich.title.fontWeight`, false)
      }
    },

    //柱上文字设置结束
    yAxisLabelPaddingWidth: {
      get() {
        if (this.axisLabelType) {
          return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank0.width"))
        } else {
          return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.padding.0"))
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.yAxis.axisLabel.rich
          const values = []
          const names = []
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length) {
              values.push(newVal)
              names.push(`chartOption.yAxis.axisLabel.rich.${k}.width`)
            }
          })
          if(values.length) {
            this.$changeOptionsEV(values, names, false)
          }
        } else {
          this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.padding.0", false)
        }
      }
    },
    yAxisLabelPaddingHeight: {
      get() {
        if (this.axisLabelType) {
          return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank0.height"))
        } else {
          return Number(this.hasProperty(this.chartOpt, "yAxis.axisLabel.padding.1"))
        }
      },
      set(newVal) {
        if (this.axisLabelType) {
          let ranks = this.chartOpt.yAxis.axisLabel.rich
          const values = []
          const names = []
          Object.keys(ranks).forEach(k => {
            if (k.includes("rank") && k.length > "rank".length) {
              values.push(newVal)
              names.push(`chartOption.yAxis.axisLabel.rich.${k}.height`)
            }
          })
          if(values.length) {
            this.$changeOptionsEV(values, names, false)
          }
        } else {
          this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.padding.1", false)
        }
      }
    },
    yAxisLabelPadding: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.padding")
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal], ["chartOption.yAxis.axisLabel.padding.0", "chartOption.yAxis.axisLabel.padding.1"], false)
      }
    },
    yAxisLabelBorderRadius: {
      get() {
        return Number(this.quickGetRankProperty("borderRadius"))
      },
      set(newVal) {
        this.forEachSetRankProperty(newVal, "borderRadius")
      }
    },
    yAxisLabelMargin: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.margin")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.margin", false)
      }
    },
    yAxisLabelRotate: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.rotate")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.rotate", false)
      }
    },
    showAxisLabelLimit() {
      return this.chartOpt.yAxis.axisLabel.hasOwnProperty("axisLabelLen")
    },
    axisLabelLen: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.axisLabelLen")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.axisLabelLen", false)
      }
    },
    axisLabelLenControl: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.axisLabel.axisLabelLenControl")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.axisLabel.axisLabelLenControl", false)
      }
    },
    yAxisInverse: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.inverse")
      },
      set(newVal) {
        const values = [newVal, !newVal, newVal ? "start" : "end"]
        const names = ["chartOption.yAxis.inverse", "chartOption.xAxis.axisLine.onZero", "chartOption.yAxis.nameLocation"]
        // y轴反转时，面积图需要反转
        if (this.chartOpt.series) {
          this.chartOpt.series.forEach((item, index) => {
            if (item.type === "line") {
              values.push(newVal ? "end" : "start")
              names.push(`chartOption.series.${index}.areaStyle.origin`)
            }
          })
        }
        this.$changeOptionsEV(values, names, false)
      }
    }
  },
  mounted() {
    this.getSingleBackground()
    if (this.chartOpt.yAxis?.splitNumber > 0) {
      this.hasSplitNumber = "self"
    }
    if (typeof this.chartOpt?.yAxis?.max !== "undefined" && this.chartOpt.yAxis.max > 0) {
      this.hasMaxMin = "self"
    }
  },
  methods: {
    getRichBgType(rich) {
      if (typeof rich.backgroundColor === "object") {
        if ("image" in rich.backgroundColor) {
          return "图片"
        } else {
          return "线性渐变"
        }
      } else {
        return "纯色"
      }
    },
    addAllDropStr(index) {
      const newValue = this.hasProperty(this.chartOpt, `yAxis.data.${index}.value`)
      const dropValue = this.hasProperty(this.chartOpt, `yAxis.data.${index}.dropValue`)
      this.$changeOptionsEV(newValue + dropValue, `chartOption.yAxis.data.${index}.value`, false)
      this.$changeOptionsEV("", `chartOption.yAxis.data.${index}.dropValue`, false)
    },
    quickGetDataProperty(name) {
      return this.hasProperty(this.chartOpt, `yAxis.data.0.textStyle.padding.2`)
    },
    quickGetRankProperty(name) {
      let str = ""
      if (name === "color") {
        str = "rgba(255,255,0,0)"
      }
      if (name === "fontFamily") {
        str = "sans-serif"
      }
      if (name === "fontSize") {
        str = 12
      }
      if (name === "fontWeight") {
        str = 400
      }
      if (name === "borderRadius") {
        str = 0
      }
      if (this.axisLabelType) {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          `yAxis.axisLabel.rich.rank0.${name}`,
          `yAxis.axisLabel.rich.rank0.${name}`,
          str
        )
      } else {
        return this.checkAndSetPrimaryVal(this.chartOpt, `yAxis.axisLabel.${name}`, `yAxis.axisLabel.${name}`, str)
      }
    },
    forEachSetRankProperty(newVal, name) {
      if (this.axisLabelType) {
        let ranks = this.chartOpt.yAxis.axisLabel.rich
        Object.keys(ranks).forEach(k => {
          if (k.includes("rank") && k.length > "rank".length) {
            this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.rich.${k}.${name}`, false)
          }
        })
      } else {
        this.$changeOptionsEV(newVal, `chartOption.yAxis.axisLabel.${name}`, false)
      }
    },
    stopChangePosition(rich, e) {
      const { backgroundColor, name } = JSON.parse(e.dataTransfer.getData("dragRank"))
      const myBackgroundColor = rich.backgroundColor
      const myRankId = rich.name
      this.$changeOptionsEV(backgroundColor, `chartOption.yAxis.axisLabel.rich.${myRankId}.backgroundColor`, false)
      this.$changeOptionsEV(myBackgroundColor, `chartOption.yAxis.axisLabel.rich.${name}.backgroundColor`, false)
      this.getSingleBackground()
    },
    startChangePosition(rich, e) {
      e.dataTransfer.setData("dragRank", JSON.stringify(rich))
    },
    changeRankBgType(rich, newType) {
      this.setRichLinearBg(rich.name, this.nowLabel)
      this.getSingleBackground()
    },
    delRchSingleColor(rich, singleBackgroundId) {
      const rankId = rich.name
      const defaultBackgroundColor = this.hasProperty(this.chartOpt, "yAxis.axisLabel.rich.rank.backgroundColor")
      this.$changeOptionsEV(defaultBackgroundColor, `chartOption.yAxis.axisLabel.rich.${rankId}.backgroundColor`, false)
      this.$changeOptionsEV(false, `chartOption.yAxis.axisLabel.rich.${rankId}.singleColor`, false)
      this.singleBackground.splice(singleBackgroundId, 1)
    },
    changePrimaryBackgroundColor(colorIndex, color) {
      let ranks = this.chartOpt.yAxis.axisLabel.rich
      this.$changeOptionsEV(
        color,
        `chartOption.yAxis.axisLabel.rich.rank.backgroundColor.colorStops.${colorIndex}.color`,
        false
      )
      Object.keys(ranks).forEach(k => {
        if (k.includes("rank") && k.length > "rank".length) {
          this.$changeOptionsEV(
            color,
            `chartOption.yAxis.axisLabel.rich.${k}.backgroundColor.colorStops.${colorIndex}.color`,
            false
          )
        }
      })
    },
    changeRichColor(rich, index, newColor) {
      const rankId = rich.name
      if (typeof index !== "undefined") {
        this.$changeOptionsEV(
          newColor,
          `chartOption.yAxis.axisLabel.rich.${rankId}.backgroundColor.colorStops.${index}.color`,
          false
        )
      } else {
        this.$changeOptionsEV(newColor, `chartOption.yAxis.axisLabel.rich.${rankId}.backgroundColor`, false)
      }
    },
    addBackgroundControl() {
      if (this.axisLabelType) {
        const rich = this.chartOpt.yAxis.axisLabel.rich
        for (let k in rich) {
          if (k.includes("rank") && k.length > "rank".length && !rich[k].singleColor) {
            this.singleBackground.push({ name: k, backgroundColor: rich[k].backgroundColor })
            this.$changeOptionsEV(true, `chartOption.yAxis.axisLabel.rich.${k}.singleColor`, false)
            break
          }
        }
      } else {
      }
    },
    getSingleBackground() {
      this.singleBackground = []
      const rich = this.chartOpt.yAxis.axisLabel.rich
      for (let k in rich) {
        if (k.includes("rank") && k.length > "rank".length && rich[k].singleColor) {
          this.singleBackground.push({ name: k, backgroundColor: rich[k].backgroundColor })
        }
      }
    },
    changeDataBGC(index, color) {
      this.$changeOptionsEV(color, `chartOption.yAxis.data.${index}.textStyle.backgroundColor`, false)
    },
    changeColorType(flag) {
      this.barSettingType = flag
    },
    checkFormatterValue() {
      if (!this.chartOpt.yAxis.axisLabel.formatter) {
        this.$changeOptionsEV("{value}{valueUnit| }", "chartOption.yAxis.axisLabel.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.yAxis.axisLabel.rich",
          false
        )
      }
    },
    getLabel(newType) {
      this.nowLabel = newType
    },
    setRichLinearBg(rankId, type) {
      let lineBg = {
        type: "linear",
        x: 0.5, //左
        y: 0.8, //上
        x2: 0, //右
        y2: 0, //下
        colorStops: [
          {
            offset: 0,
            color: "rgba(244, 6, 6, 1)" // 0% 处的颜色
          },
          {
            offset: 1,
            color: "rgba(7, 4, 170, 1)" // 100% 处的颜色
          }
        ],
        global: false // 缺省为 false
      }
      if (type === "图片") {
        lineBg = {
          image: ""
        }
      } else if (type === "纯色") {
        lineBg = "rgba(244, 6, 6, 1)"
      }
      this.$changeOptionsEV(lineBg, `chartOption.yAxis.axisLabel.rich.${rankId}.backgroundColor`, false)
    },
    typeChange() {
      if (this.hasSplitNumber === "auto") {
        this.splitNumber = 0
      }
    },
    typeChangeMaxMin() {
      if (this.hasMaxMin === "auto") {
        this.max = "dataMax"
      } else {
        this.max = 800
      }
    }
  }
}
</script>

<style scoped>
.to_input {
  display: flex;
  justify-content: space-around;
}
::v-deep.w78.color-picker-container {
  padding: 0;
  height: 32px;
}
::v-deep.w78.color-picker-container .el-color-picker {
  height: 100%;
}
::v-deep.w78 .el-color-picker__trigger {
  width: 100% !important;
  height: 100% !important;
  border-radius: 4px;
  overflow: hidden;
}
::v-deep.w78 .el-color-picker__trigger .el-color-picker__color {
  width: 100%;
  height: 100%;
}
.verticallyCenterAround {
  align-items: normal;
}
::v-deep .el-select {
  margin-bottom: 0px;
}
.bar-options-setting-dialog .tabs-color {
  width: 200px;
  height: 24px;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 5px 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.ln40 {
  line-height: 40px;
}
.flexBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-color-picker {
  height: auto;
}
.right_font {
  position: absolute;
  right: 29.5px;
  text-align: right;
  color: var(--themeColor);
}
.right_font:hover {
  cursor: pointer;
}
.single_bg {
  /* display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; */
  border: 1px solid #313336;
  border-radius: 4px;
  margin-top: 16px;
  padding: 12px;
}
.single_color_icons_bgType {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.single_color_icons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: relative;
  width: 100%;
}
.icon_set {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  top: -12px;
  background: #363a40;
}
.icon_set:first-child {
  right: 12px;
  border-radius: 0px 0px 0px 4px;
}
.icon_set:last-child {
  right: -12px;
  border-radius: 0px 4px 0px 0px;
}
.icon_set img {
  display: inline-block;
  width: 14px;
  height: 14px;
}
.icon_set img:hover {
  cursor: pointer;
}
.icon_set span:hover {
  cursor: pointer;
}
.icon_set span {
  display: inline-block;
  color: rgb(117, 120, 124);
  font-size: 14px;
}
.text-limit-box {
  margin-top: 10px;
  background: var(--cardBgColor);
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
}
.text-limit-ipt {
  margin: 0 16px;
  width: 90px;
}
.selectRichType {
  margin-top: 6px;
}
.selectRichType .el-radio {
  margin-right: 10px;
}
.selectRichType .el-radio:last-child {
  margin-right: 0;
}
</style>
